import { FC } from 'react'

/**
 * * Icon Component for: chevron-right
 */
type ChevronRightOutlineIconProps = {
  size?: number
  color?: string
}
export const ChevronRightOutlineIcon: FC<ChevronRightOutlineIconProps> = ({
  size = '1rem',
  color = 'currentColor',
  ...rest
}) => {
  const iconAttributes = {
    width: size,
    height: size,
    stroke: color,
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" fill="none" {...rest} {...iconAttributes}>
      <path d="M1 1L6 6L1 11" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
